export const APP_HOME = '/';
export const LOGIN = '/login';
export const REGISTER = '/register';
export const CONFIRM_EMAIL = '/confirm-email/patient';
export const ADMIN_CONFIRM_EMAIL = '/confirm-email';
export const RECOVER_PASSWORD = '/recover-password';
export const RESET_PASSWORD = '/reset-password';
export const LEGAL = '/legal';

const paths = {
  APP_HOME,
  LOGIN,
  REGISTER,
  CONFIRM_EMAIL,
  ADMIN_CONFIRM_EMAIL,
  RECOVER_PASSWORD,
  RESET_PASSWORD,
  LEGAL
};

export default paths;
